<template>
    <div class="container">
        <p id="titleTop">视知觉能力测试</p>
        <p>{{title}}</p>
        <div id="imgContainer">
            <img :src="imgLeft" alt="">
            <img :src="imgRight" alt="">
        </div>
        <div id="btnContainer">
            <div id="btnLeft">
                <div></div>
                <span>{{btnLeftSpan}}</span>
                <img :src="btnLeftImg" alt="">
            </div>
            <div id="btnRight">
                <div></div>
                <span>{{btnRightSpan}}</span>
                <img :src="btnRightImg" alt="">
            </div>
        </div>
        <p>{{description[0]}}</p>
        <p>{{description[1]}}<span>【{{description[2]}}】</span>或<span>【{{description[3]}}】</span>。</p>
        <div id="footer">
            <div @click=onTest>不理解？试一试</div>
            <div @click=onStart>开始测试</div>
        </div>
    </div>
</template>

<script>
    export default {
        name:'CommonDescription',
        data(){
            return{
                title:"",
                imgLeft:'',
                imgRight:'',
                btnLeftImg:'',
                btnRightImg:'',
                btnLeftSpan:'',
                btnRightSpan:'',
                description:[],
            }
        },
        methods:{
            onStart(){
                this.$store.state.global.isTest=false
                this.$router.push('/CommonTraining')
            },
            onTest(){
                this.$store.state.global.isTest=true
                this.$router.push('/CommonTraining')
            }
        },
        mounted(){
            this.$store.state.global.isTrans=true
            this.$store.state.global.isTest=false
            this.imgLeft=require('../../assets/trainingImg/'+this.$store.state.commonDescription.img[this.$store.state.global.itemNum][0])
            this.imgRight=require('../../assets/trainingImg/'+this.$store.state.commonDescription.img[this.$store.state.global.itemNum][1])
            this.title=this.$store.state.commonDescription.title[this.$store.state.global.itemNum]
            this.btnLeftImg=require('../../assets/common/'+this.$store.state.commonDescription.btnLeftImg[this.$store.state.global.itemNum])
            this.btnRightImg=require('../../assets/common/'+this.$store.state.commonDescription.btnRightImg[this.$store.state.global.itemNum])
            this.description=this.$store.state.commonDescription.description[this.$store.state.global.itemNum]
            this.btnLeftSpan=this.$store.state.commonDescription.btnLeftSpan[this.$store.state.global.itemNum]
            this.btnRightSpan=this.$store.state.commonDescription.btnRightSpan[this.$store.state.global.itemNum]
            //跳转页面
            // this.$router.push('/sejueDescription')
        },
        // beforeCreate(){
        //     if(this.$store.state.global.itemNum>6){
        //         //跳转页面
        //         this.$router.push('/sejueDescription')
        //     }
        // }
    }
</script>

<style scoped>
    .container{
        background: rgb(233,233,233);
        position: absolute;
        /* top: 8%; */
        height: 100vw;
        width: 100vh;
        transform-origin: left top;
        transform: rotate(90deg);
        left:100vw;
    }
    span{
        font-weight: bold;
    }
    p{
        text-align: center;
    }
    #titleTop{
        /* padding-top: 3vw; */
        margin-top: 3vw;
        font-size: 5vw;
    }
    p:nth-child(2){
        margin-top: 3vw;
        font-size: 6vw;
        font-weight: bolder;
    }
    #titleBottom{
        font-size: 5vw;
        font-weight: 200;
    }
    p:nth-child(5){
        font-size: 4vw;
        width: 65vh;
        line-height: 5vw;
        position: absolute;
        left:50%;
        top:62%;
        transform:translate(-50%,-50%);
        /* text-align: left; */
    }
    p:nth-child(6){
        font-size: 4vw;
        width: 65vh;
        line-height: 5vw;
        position: absolute;
        left:50%;
        top:75%;
        transform:translate(-50%,-50%);
        /* text-align: left; */
    }
    #imgContainer{
        width: 60vh;
        /* margin-top: 3vw; */
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        position: absolute;
        left:50%;
        top:22%;
        transform:translate(-50%,0%);
    }
    #imgContainer img{
        width: 20vw;
        height: 20vw;
    }

    #btnContainer{
        width: 60vh;
        /* margin-top: 5vw; */
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        position: absolute;
        left:50%;
        top:44%;
        transform:translate(-50%,0%);
    }
    #btnLeft {
        width: 30vw;
        position: relative;
    }
    #btnLeft div{
        width: 30vw;
        height: 8vw;
        background: rgb(41, 123, 255);
        border-radius: 4vw 0 0 4vw;
    }
    #btnLeft img{
        width: 8vw;
        position: absolute;
        top: 0;
        left: 0;
    }
    #btnLeft span{
        font-size: 5vw;
        position: absolute;
        top: 1.5vw;
        left: 50%;
        color: white;
    }
    #btnRight {
        width: 30vw;
        position: relative;
    }
    #btnRight div{
        width: 30vw;
        height: 8vw;
        background: rgb(41, 123, 255);
        border-radius: 0 4vw 4vw 0;
    }
    #btnRight img{
        width: 8vw;
        position: absolute;
        top: 0;
        right: 0;
    }
    #btnRight span{
        font-size: 5vw;
        position: absolute;
        top: 1.5vw;
        right: 50%;
        color: white;
    }
    #footer{
        width: 80vh;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        position: absolute;
        left:50%;
        top:88%;
        transform:translate(-50%,-50%);
    }
    #footer div{
        width: 30vh;
        height: 8vw;
        border-radius: 5vw;
        text-align: center;
        line-height: 8vw;
        font-size: 5vw;
        background: rgb(41,123,255);
        color: white;
        margin-top: 2vw;
    }
    #footer div:nth-child(1){
        background: rgb(254,192,2);
    }
</style>